import React from 'react';

interface SlideShowWordsProps {
    text: string;
}

function SlideShowWords({ text }: SlideShowWordsProps) {
    return (
        <div className="slideShowLine">
            {text}
        </div>
    );
}

export default SlideShowWords;
